import { Component, OnInit, TemplateRef, ViewChild, Input, OnDestroy,Injectable } from '@angular/core';
import { ExecutiveDashboardsService } from '@shared/services/executive-dashboards.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute, Router } from "@angular/router";
import { GlobalSettingsService } from "@shared/services/global-settings.service";
import { PropertiesService } from "@core/services/properties.service";
import { StorageService } from "@core/services/storage.service";
import { Subscription } from "rxjs";

@UntilDestroy()
@Component({
  selector: 'app-executive-dashboards',
  templateUrl: './executive-dashboards.component.html',
})
@Injectable({
  providedIn: 'root'
})
export class ExecutiveDashboardsComponent implements OnInit {

  teamId: string;
  loading: boolean;
  symptoms: any;
  date: string;
  selectedDate?: Base.DurationsModel;
  dateFilter = 'LAST_12_MONTHS';
  loadingByDate: boolean;
  activeTab;
  check = false;

  @ViewChild('noDataSourceTemplate') noDataSourceTemplate: TemplateRef<{}>;
  description: string;

  symptom: string;

  sortValue: Base.KeyValueModel;
  individualScorecard: any;
  featuresData: AdminSettings.BaseAdminModel<AdminSettings.Features>;

  level: OrganizationModel.Organization[];
  teamName: any;
  dashboardTeamsDetail: any;
  loadingDashboardTeams: boolean;
  mapOfExpandedData: { [key: string]: Team.TeamModel[] } = {};
  filterTeams: any;
  subscription: Subscription = new Subscription();

  constructor(private route: ActivatedRoute,
              private router: Router,
              private globalSettingsService: GlobalSettingsService,
              public propertiesService: PropertiesService,
              private storageService: StorageService,
              private executiveDashboardsService: ExecutiveDashboardsService,
  ) {

  }

   ngOnInit() {
    this.getDashboardeams();
  }

  getDashboardeams(): void {
    this.loadingDashboardTeams = true;
    this.executiveDashboardsService.getTeams()
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        this.dashboardTeamsDetail = response;
        this.dashboardTeamsDetail.forEach(item => {
          this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
        });
        this.loadingDashboardTeams = false;
      }, error => {
        this.loadingDashboardTeams = true;
        console.log('Error occurred while fetching initial data for Root Cause symptoms', error);
      });
  }

  collapse(array: Team.TeamModel[], data: Team.TeamModel, $event: boolean): void {
    if (!$event) {
      if (data.subTeams) {
        data.subTeams.forEach(team => {
          // tslint:disable-next-line:no-non-null-assertion
          const target = array.find(item => item.key === team.key)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }

  convertTreeToList(root: Team.TeamModel): Team.TeamModel[] {
    const stack: Team.TeamModel[] = [];
    const array: Team.TeamModel[] = [];
    const hashMap = {};
    stack.push({ ...root, level: 0, expand: this.isNodeExpanded(root) });

    while (stack.length !== 0) {
      // tslint:disable-next-line:no-non-null-assertion
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.subTeams) {
        for (let i = node. subTeams.length- 1; i >= 0; i--) {
          // tslint:disable-next-line:no-non-null-assertion
          const childNode = {...node.subTeams[i],level:node.level!+1,parent:node};
          childNode.expand = this.isNodeExpanded(childNode);
          stack.push(childNode);
        }
      }
    }
    return array;
  }
  visitNode(node: Team.TeamModel, hashMap: { [key: string]: boolean }, array: Team.TeamModel[]): void {
    if (!hashMap[node.key]) {
      hashMap[node.key] = true;
      array.push(node);
    }
  }
  isNodeExpanded(node: Team.TeamModel): boolean {
    const executiveExpandedData = JSON.parse(this.storageService.get('executiveExpandedData') || '{}');
    return executiveExpandedData[node.key] || false;
  }

  saveExpandedState(node: Team.TeamModel): void {
    const executiveExpandedData = JSON.parse(this.storageService.get('executiveExpandedData') || '{}');
    executiveExpandedData[node.key] = node.expand;

    if (!node.expand && node.subTeams) {
      const reControlChild = (parent) => {
        if (parent.subTeams.length > 0) {
          parent.subTeams.forEach(item => (reControlChild(item)));
        }
        executiveExpandedData[parent.key] = false;
      }
      reControlChild(node);
    }
    this.storageService.set('executiveExpandedData', JSON.stringify(executiveExpandedData));
  }

}



